import { render, staticRenderFns } from "./AssignAccountProfile.vue?vue&type=template&id=09a2539e&"
import script from "./AssignAccountProfile.vue?vue&type=script&lang=js&"
export * from "./AssignAccountProfile.vue?vue&type=script&lang=js&"
import style0 from "./AssignAccountProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports